"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = __importStar(require("react"));
function UndrawSnapTheMoment(p) {
  var primaryColor = p.primaryColor,
    height = p.height,
    style = p.style,
    props = __rest(p, ["primaryColor", "height", "style"]);
  var styleProps = __assign({
    width: '100%',
    height: height
  }, style);
  return React.createElement("svg", __assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 362 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: styleProps
  }, props), React.createElement("path", {
    d: "M313.314 100.377h-194.12v130.84h194.12v-130.84z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M313.796 232.108H118.338V99.931h195.458v132.177zm-194.119-1.338h192.781V101.268H119.677V230.77z",
    fill: "#3F3D56"
  }), React.createElement("path", {
    d: "M135.712 220.297h161.31V111.081h-161.31v109.216z",
    fill: "#E5E5E5"
  }), React.createElement("path", {
    d: "M263.388 166.407l-21.45-25.47-43.055.392-26.119 25.393.528.339h-.188v52.818h90.226v-52.818l.058-.654z",
    fill: "#3F3D56"
  }), React.createElement("path", {
    d: "M241.997 140.937l-26.823 31.38v47.562h48.214v-53.532l-21.391-25.41z",
    fill: "#1961FF"
  }), React.createElement("path", {
    d: "M244.638 193.564H234.37v8.475h10.268v-8.475zM244.638 178.4H234.37v8.474h10.268V178.4zM200.889 191.335h-9.821v8.474h9.821v-8.474zM200.889 176.171h-9.821v8.474h9.821v-8.474z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M316.641 50.3l-5.463 10.068 5.394 2.934s3.7-11.31 3.809-11.738a2.946 2.946 0 001.364-1.067c.33-.479.5-1.041.486-1.613a2.727 2.727 0 00-.564-1.59 2.969 2.969 0 00-1.413-1.006 3.129 3.129 0 00-1.766-.069 3.003 3.003 0 00-1.496.895 2.704 2.704 0 00-.351 3.186z",
    fill: "#A0616A"
  }), React.createElement("path", {
    d: "M288.606 51.67c2.436 8.568 11.195 14.01 18.469 20.533a7.161 7.161 0 005.495-.41 6.734 6.734 0 002.15-1.726 6.336 6.336 0 001.232-2.404l2.452-9.104-6.231-.158-2.578 2.66-8.343-5.643-12.646-3.748z",
    fill: "#CBCBCB"
  }), React.createElement("path", {
    d: "M309.61 141.175l3.777 1.616 8.367-13.052-5.573-2.386-6.571 13.822z",
    fill: "#A0616A"
  }), React.createElement("path", {
    d: "M307.7 144.855l11.612 4.972.066-.14a4.48 4.48 0 00.118-3.599c-.465-1.167-1.4-2.112-2.598-2.625l-1.395-2.435-4.684-.167-1.014-.434-2.105 4.428z",
    fill: "#2F2E41"
  }), React.createElement("path", {
    d: "M347.755 138.965l3.988-1.062-2.42-15.105-5.887 1.568 4.319 14.599z",
    fill: "#A0616A"
  }), React.createElement("path", {
    d: "M348.782 142.95l12.265-3.267-.043-.148c-.356-1.201-1.199-2.219-2.346-2.83a5.197 5.197 0 00-3.768-.428l-2.718-1.016-3.703 2.726-1.07.286 1.383 4.677zM287.392 94.827c.102 2.8 6.377 6.554 9.678 7.637.561.184.889.286.889.286l1.148-.33 13.911-.192c2.436 1.359 9.702 2.051 15.664 2.396 4.746.275 7.391 2.629 7.391 2.629 1.4 10.104 5.436 17.47 10.09 26.523l5.586-.922-5.277-33.722a3.678 3.678 0 00-.969-1.956 3.998 3.998 0 00-1.945-1.126l-37.959-9.423s-2.094-.36-6.509 1.662c-7.268 3.328-11.771 4.501-11.698 6.538z",
    fill: "#2F2E41"
  }), React.createElement("path", {
    d: "M318.839 136.857c-.055 0-.11-.003-.166-.008l-6.574-.487a1.75 1.75 0 01-1.313-.818 1.785 1.785 0 01-.163-1.557l8.798-20.102a1.403 1.403 0 00-.433-1.544 1.32 1.32 0 00-.501-.253c-4.137-1.1-14.752-4.028-23.941-7.455-3.936-1.468-6.416-3.589-7.369-6.304-1.257-3.581.602-6.846.682-6.983l.062-.108 8.647.8 9.373.81 20.541 11.202a7.88 7.88 0 013.662 4.401 8.037 8.037 0 01-.244 5.759l-9.471 21.597c-.137.312-.36.578-.642.764a1.721 1.721 0 01-.948.286z",
    fill: "#2F2E41"
  }), React.createElement("path", {
    d: "M315.537 60.747l-2.019-1a1.3 1.3 0 01-.661-.75 1.218 1.218 0 01.09-.976l4.832-8.788c.166-.3.451-.526.791-.628.341-.102.711-.071 1.028.086l2.018.999c.317.157.555.427.662.75.107.324.075.675-.09.976l-4.833 8.788c-.165.3-.45.527-.791.628-.341.102-.71.071-1.027-.085z",
    fill: "#3F3D56"
  }), React.createElement("path", {
    d: "M319.116 49.021a.763.763 0 00-.554-.046.722.722 0 00-.427.338l-4.832 8.789a.661.661 0 00-.049.526.7.7 0 00.357.404l2.018 1c.171.084.37.1.554.046a.722.722 0 00.427-.339l4.832-8.788a.661.661 0 00.049-.526.701.701 0 00-.357-.404l-2.018-1z",
    fill: "#1961FF"
  }), React.createElement("path", {
    d: "M292.465 23.159s-5.549-1.98-9.115 5.938c-3.566 7.918-9.115 16.628-9.115 16.628l3.17.792s.792-5.543 2.774-6.333l-.792 7.126s23.777 8.314 34.476-.792l-.396-2.772s1.586.397 1.586 2.772l1.189-1.188s-1.189-2.376-4.755-5.543c-2.341-2.079-3.145-6.034-3.422-8.507a10.29 10.29 0 00-2.372-5.606c-2.371-2.744-6.69-5.66-13.228-2.515z",
    fill: "#2F2E41"
  }), React.createElement("path", {
    d: "M296.4 45.456c5.951 0 10.774-4.292 10.774-9.586 0-5.294-4.823-9.586-10.774-9.586-5.951 0-10.775 4.292-10.775 9.586 0 5.294 4.824 9.586 10.775 9.586z",
    fill: "#A0616A"
  }), React.createElement("path", {
    d: "M283.184 38s4.933-5.737 7.707-6.528a23.865 23.865 0 004.793-1.946s5.51 5.113 9.869 5.509c4.359.396-.711-8.424-.711-8.424l-6.818-3.055-7.53.791-5.944 3.96L283.184 38z",
    fill: "#2F2E41"
  }), React.createElement("path", {
    d: "M315.513 58.63l-7.884 8.502 4.477 4.093s6.494-10.112 6.71-10.503a3.05 3.05 0 001.597-.72c.443-.387.752-.893.885-1.451a2.682 2.682 0 00-.138-1.672 2.859 2.859 0 00-1.112-1.303 3.096 3.096 0 00-1.696-.475 3.09 3.09 0 00-1.68.521 2.85 2.85 0 00-1.072 1.333 2.692 2.692 0 00-.087 1.676z",
    fill: "#A0616A"
  }), React.createElement("path", {
    d: "M287.972 53.473c.162 8.873 7.259 16.177 12.637 24.186.792.497 1.684.83 2.62.981.936.15 1.895.114 2.815-.107a6.98 6.98 0 002.529-1.177 6.57 6.57 0 001.812-2.046l4.716-8.262-6.002-1.595-3.184 1.983-6.642-7.402-11.301-6.561z",
    fill: "#CBCBCB"
  }), React.createElement("path", {
    d: "M287.619 95.927c-.019 0-.461-1.098-.47-1.1-.15-.04-2.186-.23-1.728-3.429l.586-3.52-.572-3.107-.962-.912 1.546-1.467-.947-6.652-.364-13.318c-.913-4.575-.674-8.76 3.747-10.774l5.069-4.462 5.768-.066 2.733 5.582 3.17 5.998 5.041 14.355.918 2.033-.079.068c-.006.005-.617.53-.892.819-.133.18.116 1.519.425 2.656l.395 2.808-.996.676 1.295 1.453 3.533 5.666-.212-.05c-.238-.057-2.46 3.108-26.841 6.626-.112.016-.116.117-.163.117z",
    fill: "#CBCBCB"
  }), React.createElement("path", {
    d: "M0 101.04C0 71.084 24.307 0 54.29 0c29.985 0 54.292 71.084 54.292 101.04a54.212 54.212 0 01-15.956 38.253 54.319 54.319 0 01-38.335 15.832 54.319 54.319 0 01-38.334-15.832A54.215 54.215 0 010 101.04z",
    fill: "#E5E5E5"
  }), React.createElement("path", {
    d: "M54.29 233a.446.446 0 01-.446-.446V45.552a.446.446 0 01.893 0v187.002a.444.444 0 01-.446.446z",
    fill: "#CCC"
  }), React.createElement("path", {
    d: "M54.29 81.654a.446.446 0 01-.315-.13L32.487 60.055a.446.446 0 01.631-.631l21.488 21.468a.447.447 0 01-.315.761zM54.29 118.82a.446.446 0 01-.315-.761l35.986-35.953a.446.446 0 11.642.62l-.01.01-35.987 35.954a.445.445 0 01-.315.131v-.001z",
    fill: "#CCC"
  }), React.createElement("path", {
    d: "M361.554 232.999H29.864a.449.449 0 01-.447-.446.446.446 0 01.447-.446h331.69a.445.445 0 110 .892z",
    fill: "#E6E6E6"
  }), React.createElement("path", {
    d: "M69.586 198.752c0-7.673 6.23-25.883 13.916-25.883s13.918 18.208 13.918 25.883c0 3.688-1.467 7.224-4.077 9.832a13.925 13.925 0 01-19.681 0 13.898 13.898 0 01-4.076-9.832z",
    fill: "#1961FF"
  }), React.createElement("path", {
    d: "M83.502 232.553a.116.116 0 01-.08-.033.116.116 0 01-.034-.081v-47.904a.12.12 0 01.034-.081.11.11 0 01.037-.024.11.11 0 01.087 0 .11.11 0 01.062.062.108.108 0 01.01.043v47.904c0 .03-.013.059-.034.081a.116.116 0 01-.081.033z",
    fill: "#E6E6E6"
  }), React.createElement("path", {
    d: "M83.502 193.784a.11.11 0 01-.043-.009.1.1 0 01-.037-.025l-5.509-5.499a.114.114 0 01.081-.194c.03 0 .06.012.081.033l5.509 5.499a.114.114 0 01-.081.195zM83.502 203.305a.112.112 0 01-.063-.02.115.115 0 01-.049-.117.113.113 0 01.032-.058l9.224-9.21a.112.112 0 01.162 0 .113.113 0 010 .161l-9.225 9.21a.112.112 0 01-.08.034z",
    fill: "#E6E6E6"
  }));
}
exports.default = UndrawSnapTheMoment;